import React from "react";
import { Box, useMediaQuery, useTheme } from "@mui/material";
import RolePermissionContainer from "../../components/RolePermissionContainer";

const RolePermissionPage: React.FC = () => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box padding={isSmallScreen ? 2 : 3}>
      <RolePermissionContainer />
    </Box>
  );
};

export default RolePermissionPage;
